import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { PlayerScore } from '@sorare/core/src/components/scoring/PlayerScore';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import type { TotalAveragePlayerScore } from '@sorare/core/src/lib/averagePlayerScore';

import { WithPlayerAppearancesCell } from '../WithPlayerAppearancesCell';
import type { AveragePlayerScoreCell_anyPlayer } from './__generated__/index.graphql';

type Props = {
  anyPlayer: AveragePlayerScoreCell_anyPlayer;
  mode: TotalAveragePlayerScore;
};

export const AveragePlayerScoreCell = ({ mode, anyPlayer }: Props) => {
  const { up: laptopOrAbove } = useScreenSize('laptop');

  return (
    <WithPlayerAppearancesCell anyPlayer={anyPlayer} mode={mode}>
      <PlayerScore
        player={anyPlayer}
        mode={mode}
        small={!laptopOrAbove}
        hideTooltip
      />
    </WithPlayerAppearancesCell>
  );
};

AveragePlayerScoreCell.fragments = {
  anyPlayer: gql`
    fragment AveragePlayerScoreCell_anyPlayer on AnyPlayerInterface {
      slug
      ...PlayerScore_anyPlayer
      ...WithPlayerAppearancesCell_anyPlayer
    }
    ${PlayerScore.fragments.anyPlayer}
    ${WithPlayerAppearancesCell.fragments.anyPlayer}
  ` as TypedDocumentNode<AveragePlayerScoreCell_anyPlayer>,
};
